export async function markNotificationAsRead(notificationId: string) {
  try {
    const response = await fetch("/profile/notifications/mark-as-read", {
      method: "POST",
      body: JSON.stringify({ notificationId, readAt: new Date() }),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return {
        message:
          res.update_party_notifications.affected_rows == 1
            ? "Notification marked as read"
            : "Error: Notification not marked as read",
      };
    }
    return { message: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { message: undefined, errors: err };
  }
}

export async function markAllNotificationsAsRead() {
  try {
    const response = await fetch("/profile/notifications/mark-all-as-read", {
      method: "POST",
      body: JSON.stringify({}),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return { message: res.markAllNotificationsAsRead.message };
    }
    return { message: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { message: undefined, errors: err };
  }
}
